import Hero from '../components/Hero';
import CoursesSection from '../components/CoursesSection';
import Pillars from '../components/Pillars';
import TrustpilotReviews from '../components/TrustpilotReviews';
import StatsBand from '../components/StatsBand';
import TestimonialStack from '../components/TestimonialStack';
import HowItWorks from '../components/HowItWorks';
import TutorsSection from '../components/TutorsSection';
import FAQ from '../components/FAQ';
import CTABand from '../components/CTABand';

/**
 * Homepage order (per client brief):
 *   Hero (with compact Trustpilot badge inline) → Courses → Why Science Sorted
 *   → Trustpilot reviews (full carousel) → Results → How it works
 *   → Tutors → FAQ → Final CTA → Footer
 */
export default function Home() {
  return (
    <main>
      <Hero />
      <CoursesSection />
      <Pillars />
      <TrustpilotReviews />
      <StatsBand />
      <TestimonialStack />
      <HowItWorks />
      <TutorsSection />
      <FAQ />
      <CTABand />
    </main>
  );
}
